/*
 * Plays one alarm sound at a time.
 *
 * Each sound plays to the end, once, and the button goes back to play.
 */
(() => {
  document.querySelectorAll('[data-wake-sounds]').forEach((root) => {
    const audio = new Audio();
    audio.volume = 0.7;
    let current = null;

    const stop = () => {
      audio.pause();
      if (current) current.setAttribute('aria-pressed', 'false');
      current = null;
    };

    root.addEventListener('click', (event) => {
      const button = event.target.closest('.wake-sound');
      if (!button) return;

      const same = button === current;
      stop();
      if (same) return;

      audio.src = button.dataset.src;
      audio.currentTime = 0;
      audio.play().catch(stop);
      button.setAttribute('aria-pressed', 'true');
      current = button;
    });

    audio.addEventListener('ended', stop);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) stop();
    });
  });
})();
